import React from 'react';
import { Table } from 'semantic-ui-react';
import {
  columnCreatedOn,
  columnDescription,
  columnName,
  columnNameLink,
  columnSize,
  columnTools,
  columnType,
  hasColumn,
} from '@/constants/fields';
import { formatBytes } from '@/utils/fileHelper';
import NameDescriptionRow from '@/components/table/NameDescriptionRow';
import { uploadEndpointDatasetAttachments } from '@/constants/urls';
import SimpleCell from '@/components/table/SimpleCell';
import DateCell from '@/components/table/DateCell';
import { downLoadableAttachmentIcon } from '../helper';
import AttachmentTypeFlag from './AttachmentTypeFlag';
import AttachmentToolsMenu from './AttachmentToolsMenu';
import DatasetAttachmentManageCells from './DatasetAttachmentManageCells';
import DatasetAttachmentDescriptionCell from './DatasetAttachmentDescriptionCell';
import Selectors from '../hooks/selectors';
import Events from '../hooks/events';

const DatasetAttachmentRow = ({
  category,
  code,
  columns,
  attachment,
  upward,
}) => {
  const {
    canDownload, canUpdate, isDownloading, isEditing, isLoading, theme, isRoot,
  } = Selectors.useDatasetAttachmentRow({ category, code, attachment });
  const downloadStart = Events.useDatasetAttachmentDownload(category, { code });

  const {
    iconName, iconTitle, color, exceedsDownloadSize, warning,
  } = downLoadableAttachmentIcon(attachment, isDownloading);
  const nameColumn = canDownload && !isDownloading && !exceedsDownloadSize ? columnNameLink : columnName;
  const cols = columns.map((column) => ([columnName, columnNameLink].includes(column) ? nameColumn : column));

  return (
    <NameDescriptionRow
      asHref
      columns={cols.filter((column) => column !== columnDescription)}
      disabled={isDownloading}
      href={uploadEndpointDatasetAttachments(code, attachment.id)}
      icon={iconName}
      iconColour={color}
      loading={isDownloading}
      name={attachment.name}
      nameMessageId={iconTitle}
      onClick={() => downloadStart({ attachment })}
      warning={canUpdate && warning}
    >
      {hasColumn(cols, columnDescription) && (
        <DatasetAttachmentDescriptionCell
          attachment={attachment}
          canEdit={canUpdate}
          category={category}
          code={code}
          theme={theme}
        />
      )}
      {hasColumn(cols, columnType) && (
        <Table.Cell className="td-name">
          <AttachmentTypeFlag attachment={attachment} />
        </Table.Cell>
      )}
      {hasColumn(cols, columnSize) && (<SimpleCell content={formatBytes(attachment.size, false)} />)}
      <DatasetAttachmentManageCells
        attachment={attachment}
        canManage={canUpdate && !isEditing}
        disabled={!isRoot}
        category={category}
        code={code}
        columns={cols}
        isLoading={isLoading}
        upward={upward}
      />
      {hasColumn(cols, columnCreatedOn) && <DateCell content={attachment.created_at} />}
      {hasColumn(cols, columnTools) && (
        <Table.Cell collapsing className="aridhia-attachment-tools">
          <AttachmentToolsMenu
            attachment={attachment}
            category={category}
            code={code}
            exceedsDownloadSize={exceedsDownloadSize}
            isDownloading={isDownloading}
            upward
          />
        </Table.Cell>
      )}
    </NameDescriptionRow>
  );
};

export default DatasetAttachmentRow;
